import { useState } from "react";

import Image from "next/image";
import { useIntl, FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";
import { useIntersectionObserver } from "@/lib/hooks/use-intersection-observer";

interface GoogleMapProps {
  mapUrl: string;
}

export default function GoogleMap({ mapUrl }: GoogleMapProps) {
  const intl = useIntl();
  const [showMap, setShowMap] = useState(false);

  const [mapRef] = useIntersectionObserver({
    rootMargin: "-200px 0px 0px 0px",
    threshold: 0,
    onChange: (isIntersecting) => {
      if (isIntersecting) {
        setShowMap(true);
      }
    },
  });

  return (
    <div className="tw-py-40" id="location_section">
      <Text element="h2" typeface="headline-2-m" className="tw-my-12">
        <FormattedMessage
          id="listing.listing_main.location_header"
          defaultMessage="Location"
        />
      </Text>
      <div ref={mapRef} className="tw-relative tw-aspect-[32/17]">
        {showMap && (
          <Image
            src={`https://maps.google.com${mapUrl}`}
            fill
            alt={intl.formatMessage({
              id: "staticMap.map.image",
              defaultMessage: "static map",
            })}
            unoptimized
          />
        )}
      </div>
    </div>
  );
}
